export enum DayTypesEnum {
  WorkingDay = 1,
  Weekend = 2,
}
